import { useEffect, useState, type CSSProperties } from 'react';

import classNames from 'classnames';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../stores/useStores';
import { DEFAULT_TIMER, formatTime } from '../../../../utils/time';

const QuestTimer = observer(
  ({
    elementStyle,
    className,
    onEnd,
    timerFormat,
  }: {
    elementStyle?: CSSProperties;
    className?: string;
    onEnd: () => void;
    timerFormat?: 'short' | 'long';
  }) => {
    const { questStore } = useStores();
    const { t } = useTranslation();
    const { currentPlayerQuest } = questStore;
    const { expiredAt } = currentPlayerQuest ?? {};

    const secondsToDate = expiredAt ? dayjs(expiredAt).diff(dayjs(), 'seconds') : 0;
    const [timer, setTimer] = useState<string>(secondsToDate > 0 ? formatTime(secondsToDate, 's', t) : DEFAULT_TIMER);

    useEffect(() => {
      const interval = setInterval(() => {
        const secsToDate = dayjs(expiredAt).diff(dayjs(), 'seconds');
        if (secsToDate <= 0) {
          setTimer(DEFAULT_TIMER);
          clearInterval(interval);
          onEnd();
        } else {
          const timerFormatted = formatTime(secsToDate, 's', t);
          setTimer(timerFormatted);
        }
      }, 1000);

      return () => clearInterval(interval);
    }, [expiredAt, onEnd, timerFormat, t]);

    return (
      <div className={classNames('timer', className)} style={elementStyle}>
        {timer}
      </div>
    );
  },
);

export default QuestTimer;
